export const CHANGE_PASSWORD = "changePassword";
export const GET_CLIENT_PREFERENCES = "clientPreferences";
export const CORRESPONDENCE_DELIVERY_PREFERENCE = "correspondenceDeliveryPreference";
